const routes = {
  login: '/login',
  signup: '/signup',
  loginOTP: '/login-otp',
  verifyNumber: '/verify-number',
  verifyEmail: '/verify-email',
  verifiedOTP: '/otp-verified',
  newApplication: '/form',
  applicationForm: '/application',
  applications: '/applications',
  history: '/history',
  offerLetter: '/offerLetter',
  onboardQues: '/onboardQues',
  interviewSlots: '/interviewSlots',
  interview: '/interview',
  withdrawal: '/withdrawal',
  landingPage: '/old-landing',
  demlandingpage: '/digital-enterprise-management',
  gscmlandingpage: '/global-supply-chain-management',
  success: '/success',
  verify: '/verify',
  verifyRegistration: '/verify-registration',
  resetpassword: '/reset-password-request',
  resetPasswordMain: '/reset-password',
  embalandingpage: '/executive-mba',
  spmlandingpage: '/summer-program-management',
  phdlandingpage: '/doctor-of-philosophy',
  ephdlandingpage: '/executive-phd',
  newlandingpage: '/',

  // Layout Routes
  home: '/app/home',
  exedDashboard: '/app/exed-dashboard',
  exedGroupDashboard: '/app/exed-group-dashboard',
  exedGroupDashboardAnalysis: '/app/exed-group-dashboard-analysis',
  exedCourses: '/app/exed-courses',
  document: '/app/document',
  myApplications: '/app/my-applications',
  feePayments: '/app/feePayments',
  feeStructure: '/app/feeStructure',
  courses: '/app/courses',
  feeDetails: '/app/feeDetails',
  feePaymentHistory: '/app/paymentHistory',
  billing: '/app/billing',
  paymentSummary: '/app/payment-summary',
  faq: '/app/faq',
  elibility: '/app/eligibility',
  profile: '/app/profile',
  organizationInfo: '/app/organization-info',
  confirmation: '/lead/confirmation',
  resendVerification: '/resend-verification',
  queryHistory: '/app/queryHistory',
  queryView: '/app/queryView',
  service: '/app/service',
  faqDetail: '/app/service/faq/:categoryId',
  ticketPreview: '/service-support/ticket-preview',
  studentInterviewTab: '/app/studentInterviewTab',
  slotInterviewBooking: '/app/slotInterviewBooking',
  nominations: '/app/nominations',
  nominationOverview: '/app/nominations/overview',
  nomineeList: '/app/nominations/program/:programId',
  groupApplication: '/group-application',

  // New TicketTabs Route
  ticketTabs: '/app/ticket-tabs' // <-- added
};

export default routes;
